module.exports = __webpack_public_path__ + "static/services-cs-pod-half-40589d5a9a791ac84f7957b663d84a60.jpg";